import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useState } from 'react';
import { StyledButton } from '../../../../../../../common/Styleguide/Common/Button';
import { StyledBodyText } from '../../../../../../../common/Styleguide/Common/Text';
import CommercialDetailsPopupContent from '../../CommercialDetailsPopupContent';

const SubmissionCommercialInfoButton = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const handleOpenDetailsModal = () => {
    setIsDetailsModalOpen(true);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
  };

  return (
    <>
      <StyledButton
        sx={{
          borderRadius: '8px',
          width: '100%',
        }}
        variant="contained"
        onClick={handleOpenDetailsModal}
      >
        Commercial info
      </StyledButton>
      {isDetailsModalOpen && (
        <Dialog open={isDetailsModalOpen} onClose={handleCloseDetailsModal} maxWidth="md" fullWidth>
          <DialogTitle>
            <StyledBodyText variant="h2" sx={{ margin: 0 }}>
              Commercial info
            </StyledBodyText>
          </DialogTitle>
          <DialogContent dividers>
            <CommercialDetailsPopupContent />
          </DialogContent>
          <DialogActions>
            <StyledButton variant="contained" onClick={handleCloseDetailsModal}>
              Close
            </StyledButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default SubmissionCommercialInfoButton;
